import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import {
  Variables,
  useBulkCreatePolicyAssignments,
} from 'modules/timeoff/hooks/useBulkCreatePolicyAssignments'

interface Props {
  loading: boolean
  timeoffPolicyId: number
  timeoffPolicyEmployeeIds: number[]
  onClose: () => void
}

const AddEmployeeAssignment = ({
  loading,
  timeoffPolicyId,
  timeoffPolicyEmployeeIds,
  onClose,
}: Props) => {
  const [selectedEmployees, setSelectedEmployees] = React.useState<
    EmployeeForSelectFragmentNoAccess[]
  >([])

  const { loading: loadingBulkCreate, create: bulkCreate } = useBulkCreatePolicyAssignments({
    onCompleted(data) {
      if (data.timeoffMutations.bulkCreateTimeoffCurrentPolicyAssignment?.errors.length) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('settings.timeoff_policies.add_employees_modal.assign.error'),
          time: 2000,
        })
      } else {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
          time: 2000,
        })
      }
    },
  })

  const bulkCreateAndClosePortal = (data: Variables, closePortal: ClosePortalFn) => {
    bulkCreate(data).then(() => {
      closePortal()
      onClose()
    })
  }

  const addEmployees = async (closePortal: ClosePortalFn) =>
    bulkCreateAndClosePortal(
      {
        employeeIds: selectedEmployees.map((employee) => employee.id),
        timeoffPolicyId,
      },
      closePortal
    )

  return (
    <Modal
      illustration="alert"
      title={i18n.t('settings.timeoff_policies.add_employees_modal.assign.title')}
      description={i18n.t('settings.timeoff_policies.add_employees_modal.assign.description')}
      onClose={onClose}
      onSubmit={addEmployees}
      disableFocusTrap
      footer={
        <Button disabled={selectedEmployees.length === 0 || loading} submit>
          {i18n.t('settings.timeoff_policies.add_employees_modal.button')}
        </Button>
      }
    >
      {loadingBulkCreate || loading ? (
        <Loading />
      ) : (
        <EmployeeSelector
          value={selectedEmployees}
          onSelect={setSelectedEmployees}
          excludeIds={timeoffPolicyEmployeeIds}
          multiple
        />
      )}
    </Modal>
  )
}

export default observer(AddEmployeeAssignment)
